import { UserProfile } from "@clerk/clerk-react";

export const UserProfilePage = () => {
  return <UserProfile />;
};
